export default "__VITE_ASSET__b188124f__"